export const SHARE_PAGE = 'share-page';
export const PROFILE_PAGE = 'profile-page';
export const DEFAULT_THUMBNAIL = 'default-thumbnail';
export const TAG_PAGE = 'tag-page';
export const HISTORY_PAGE = 'history-page';
